import AdultSymptomExercisePage from "@/components/AdultSymptomExercisePage";
import { isAdultExerciseGroup } from "@/lib/data/contentCatalog";
import { createFileRoute } from "@tanstack/react-router";
import ExerciseImage from "@/assets/exercise-background-photos/physical-pain.jpg";
import physicalPainMp4 from "@/assets/videos/adults-symptoms/physical-pain/physical-pain.mp4";
import physicalPainWebm from "@/assets/videos/adults-symptoms/physical-pain/physical-pain.webm";
import physicalPainAr from "/subs/physical-pain.ar.vtt";
import physicalPainEn from "/subs/physical-pain.en.vtt";
import { useLocaleStore } from "@/lib/stores/localeStore";

export const Route = createFileRoute(
  "/(content)/adults/exercises/physical-pain/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode:
      search.mode === "videos" || search.mode === "exercises"
        ? (search.mode as "videos" | "exercises")
        : undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Physical Pain - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "exercises.categories.physicalPain",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: "ltr" | "rtl" = locale === "ar" ? "rtl" : "ltr";

  const videos = [
    {
      sources: [
        { src: physicalPainWebm, type: "video/webm" },
        { src: physicalPainMp4, type: "video/mp4" },
      ],
      videoClassName: "w-full h-full object-contain bg-black/40",
      subtitleTracks: [
        { src: physicalPainAr, srcLang: "ar", label: "Arabic", default: true },
        { src: physicalPainEn, srcLang: "en", label: "English" },
      ],
      activeSubtitleLanguage: locale === "ar" ? "ar" : "en",
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="physical-pain"
      titleKey="exercises.categories.physicalPain"
      heroImage={ExerciseImage}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === "exercises" ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: "exercises", group: nextGroup },
        })
      }
    />
  );
}
